import React from 'react';

const Education = () => {
  return (
    <section className="mt-10 md:mt-20 px-4 md:px-8">
      <h2 className="text-2xl md:text-3xl text-center font-mono mb-8 md:mb-16">
        <span className="text-green-500">&lt;</span>
        <span className="text-[#ff00ff]">EDUCATION</span>
        <span className="text-green-500">/&gt;</span>
      </h2>

      <div className="border-2 border-[#ff00ff] p-4 md:p-6 font-mono">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-2">
          <div>
            <h3 className="text-lg md:text-xl text-cyan-400">
              B.E Computer Science and Engineering
            </h3>
            <p className="text-green-500 mt-2">
              Dayananda Sagar College of Engineering | Bangalore, IN
            </p>
          </div>
          <p className="text-[#ff00ff] whitespace-nowrap">
            August 2019 -- July 2023
          </p>
        </div>
        <p className="text-green-500 mt-4">CGPA: 9.58</p>
      </div>
    </section>
  );
};

export default Education;